import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { class: "login" }
const _hoisted_2 = {
  class: "slide-up form-wrapper",
  style: {"padding":"0","width":"500px","max-height":"90vh","overflow":"auto"}
}
const _hoisted_3 = { style: {"padding":"30px"} }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 2,
  style: {"color":"red","margin-bottom":"20px"}
}
const _hoisted_6 = { style: {"margin-bottom":"10px"} }
const _hoisted_7 = { style: {"margin-bottom":"10px"} }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["value"]
const _hoisted_10 = {
  key: 0,
  style: {"margin":"0 0 5px","font-size":"16px"}
}
const _hoisted_11 = { key: 0 }
const _hoisted_12 = ["placeholder", "onUpdate:modelValue"]
const _hoisted_13 = ["placeholder", "onUpdate:modelValue"]
const _hoisted_14 = ["onUpdate:modelValue"]
const _hoisted_15 = ["onUpdate:modelValue"]
const _hoisted_16 = {
  value: undefined,
  disable: ""
}
const _hoisted_17 = ["value"]
const _hoisted_18 = {
  key: 1,
  style: {"color":"red","margin-bottom":"10px"}
}
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = {
  key: 0,
  class: "error-msg-wrap"
}
const _hoisted_21 = { class: "error-msg" }
const _hoisted_22 = { style: {"font-size":"24px"} }
const _hoisted_23 = {
  key: 1,
  class: "error-msg-wrap"
}
const _hoisted_24 = { class: "error-msg" }
const _hoisted_25 = {
  key: 0,
  style: {"margin-bottom":"15px"}
}
const _hoisted_26 = {
  key: 1,
  style: {"margin-bottom":"15px"}
}
const _hoisted_27 = { style: {"margin-bottom":"15px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_phone_input = _resolveComponent("phone-input")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (!_ctx.newLogin)
          ? (_openBlock(), _createElementBlock("form", {
              key: 0,
              onSubmit: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"]))
            }, [
              (_ctx.hideCompanyInput)
                ? (_openBlock(), _createElementBlock("h3", _hoisted_4, _toDisplayString(_ctx.companyName), 1))
                : _withDirectives((_openBlock(), _createElementBlock("input", {
                    key: 1,
                    placeholder: "Company Name",
                    type: "text",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.companyName) = $event))
                  }, null, 512)), [
                    [_vModelText, _ctx.companyName]
                  ]),
              _createVNode(_component_phone_input, {
                modelValue: _ctx.phone,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.phone) = $event))
              }, null, 8, ["modelValue"]),
              _withDirectives(_createElementVNode("input", {
                placeholder: "Password",
                type: "password",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.password) = $event))
              }, null, 512), [
                [_vModelText, _ctx.password]
              ]),
              _createElementVNode("input", {
                style: {"margin-bottom":"20px"},
                value: "Log In",
                type: "submit",
                placeholder: "Submit",
                class: _normalizeClass(_ctx.submitted ? 'btn disable-button' : 'btn')
              }, null, 2),
              (_ctx.loginError)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.loginErrorMessage), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("a", {
                  onClick: _cache[3] || (_cache[3] = _withModifiers(() => { _ctx.showPasswordReset = true; }, ["prevent"])),
                  style: {"text-decoration":"underline"}
                }, "Forgot your Password?")
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("a", {
                  onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.showRegister()), ["prevent"])),
                  style: {"text-decoration":"underline"}
                }, "New User? Register Now")
              ]),
              (_ctx.$route.query.redirect)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 3,
                    to: '/admin-login?redirect=' + encodeURIComponent(_ctx.$route.query.redirect)
                  }, {
                    default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                      _createTextVNode("Admin Login", -1)
                    ]))]),
                    _: 1
                  }, 8, ["to"]))
                : (_openBlock(), _createBlock(_component_router_link, {
                    key: 4,
                    to: "/admin-login"
                  }, {
                    default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                      _createTextVNode("Admin Login", -1)
                    ]))]),
                    _: 1
                  }))
            ], 32))
          : (_openBlock(), _createElementBlock("form", {
              key: 1,
              onSubmit: _cache[16] || (_cache[16] = _withModifiers(($event: any) => (_ctx.submitNew()), ["prevent"]))
            }, [
              _createElementVNode("h3", null, [
                _cache[23] || (_cache[23] = _createTextVNode("Request to Join", -1)),
                (_ctx.hideCompanyInput)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.companyName), 1))
                  : _createCommentVNode("", true)
              ]),
              (!_ctx.hideCompanyInput)
                ? _withDirectives((_openBlock(), _createElementBlock("input", {
                    key: 0,
                    placeholder: "Company Name*",
                    type: "text",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.companyName) = $event)),
                    onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.getRegistrationForm()))
                  }, null, 544)), [
                    [_vModelText, _ctx.companyName]
                  ])
                : _createCommentVNode("", true),
              _createVNode(_component_phone_input, {
                modelValue: _ctx.phone,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.phone) = $event)),
                placeholder: "Phone Number*"
              }, null, 8, ["modelValue"]),
              _withDirectives(_createElementVNode("input", {
                placeholder: "First Name*",
                type: "text",
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.firstName) = $event))
              }, null, 512), [
                [_vModelText, _ctx.firstName]
              ]),
              _withDirectives(_createElementVNode("input", {
                placeholder: "Last Name*",
                type: "text",
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.lastName) = $event))
              }, null, 512), [
                [_vModelText, _ctx.lastName]
              ]),
              _cache[25] || (_cache[25] = _createElementVNode("h4", { style: {"margin":"0 0 5px","font-size":"16px"} }, "Location*", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.location) = $event))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locations, (l, i) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: i,
                    value: l
                  }, _toDisplayString(l), 9, _hoisted_9))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.location]
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "email",
                placeholder: "Email*",
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.newEmployeeData.Email) = $event))
              }, null, 512), [
                [_vModelText, _ctx.newEmployeeData.Email]
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newEmployeeData.AdditionalFieldsJSON, (field, i) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
                  (field.type == 'date')
                    ? (_openBlock(), _createElementBlock("h4", _hoisted_10, [
                        _createTextVNode(_toDisplayString(field.name), 1),
                        (field.requiredOnRegistration)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_11, "*"))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (field.type == 'text')
                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 1,
                        type: "text",
                        placeholder: field.name + (field.requiredOnRegistration ? '*' : ''),
                        "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                      }, null, 8, _hoisted_12)), [
                        [_vModelText, field.value]
                      ])
                    : (field.type == 'multitext')
                      ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
                          key: 2,
                          placeholder: field.name + (field.requiredOnRegistration ? '*' : ''),
                          "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                        }, null, 8, _hoisted_13)), [
                          [_vModelText, field.value]
                        ])
                      : (field.type == 'date')
                        ? _withDirectives((_openBlock(), _createElementBlock("input", {
                            key: 3,
                            type: "date",
                            "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                          }, null, 8, _hoisted_14)), [
                            [_vModelText, field.value]
                          ])
                        : (field.type == 'select')
                          ? _withDirectives((_openBlock(), _createElementBlock("select", {
                              key: 4,
                              "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                            }, [
                              _createElementVNode("option", _hoisted_16, _toDisplayString(field.name) + "*", 1),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(field.options, (op, j) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  key: 'op'+j,
                                  value: op
                                }, _toDisplayString(op), 9, _hoisted_17))
                              }), 128))
                            ], 8, _hoisted_15)), [
                              [_vModelSelect, field.value]
                            ])
                          : _createCommentVNode("", true)
                ], 64))
              }), 128)),
              _withDirectives(_createElementVNode("input", {
                placeholder: "Password*",
                type: "password",
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.newPassword) = $event))
              }, null, 512), [
                [_vModelText, _ctx.newPassword]
              ]),
              _withDirectives(_createElementVNode("input", {
                placeholder: "Confirm Password*",
                type: "password",
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.newPasswordConfirm) = $event))
              }, null, 512), [
                [_vModelText, _ctx.newPasswordConfirm]
              ]),
              _createElementVNode("input", {
                style: {"margin-bottom":"20px"},
                value: "Register",
                type: "submit",
                placeholder: "Submit",
                class: _normalizeClass(_ctx.submitted ? 'btn disable-button' : 'btn')
              }, null, 2),
              (_ctx.loginError)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_ctx.loginErrorMessage), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", null, [
                _cache[24] || (_cache[24] = _createTextVNode("Already have an account? ", -1)),
                _createElementVNode("a", {
                  onClick: _cache[15] || (_cache[15] = _withModifiers(($event: any) => (_ctx.showLogIn()), ["prevent"])),
                  style: {"text-decoration":"underline"}
                }, "Log In")
              ])
            ], 32))
      ])
    ]),
    _createElementVNode("div", { innerHTML: _ctx.appHeightOverride }, null, 8, _hoisted_19),
    (_ctx.registrationSubmitted)
      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, "Your request to join the " + _toDisplayString(_ctx.companyName) + " Ironbook has been submitted!", 1),
            _cache[26] || (_cache[26] = _createElementVNode("div", { style: {"margin-top":"15px"} }, "You will be able to log in once your request has been approved. You can now close this window.", -1))
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showPasswordReset)
      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _cache[27] || (_cache[27] = _createElementVNode("div", { style: {"font-size":"24px"} }, "Enter your phone number. If there is an account, you will receive a text message with a link to reset your password.", -1)),
            (_ctx.hideCompanyInput)
              ? (_openBlock(), _createElementBlock("h3", _hoisted_25, _toDisplayString(_ctx.companyName), 1))
              : (_openBlock(), _createElementBlock("div", _hoisted_26, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    placeholder: "Company",
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.companyName) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.companyName]
                  ])
                ])),
            _createElementVNode("div", _hoisted_27, [
              _createVNode(_component_phone_input, {
                modelValue: _ctx.phone,
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.phone) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", {
              onClick: _cache[19] || (_cache[19] = () => { _ctx.showPasswordReset = false }),
              class: "btn-invert",
              style: {"margin-right":"10px"}
            }, "Cancel"),
            _createElementVNode("div", {
              onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.submitPasswordReset())),
              class: "btn",
              style: {"margin-left":"10px"}
            }, "Submit")
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}